export default __webpack_public_path__ + "static/media/6_template.9c99b84a.svg";